import { createSlice } from "@reduxjs/toolkit";

type RequestLoaderState = {
  loading: boolean;
  hideRequestLoader: boolean;
};

const initialState: RequestLoaderState = {
  loading: false,
  hideRequestLoader: false,
};

export const requestLoaderSlice = createSlice({
  name: "requestLoader",
  initialState,
  reducers: {
    startRequestLoader(state) {
      state.loading = true;
    },
    stopRequestLoader(state) {
      state.loading = false;
    },
    toggleHideRequestLoader(state) {
      state.hideRequestLoader = !state.hideRequestLoader;
    },
  },
});

export const {
  startRequestLoader,
  stopRequestLoader,
  toggleHideRequestLoader,
} = requestLoaderSlice.actions;
